import { Injectable, Inject } from '@angular/core';
import { Szma103aRequest, Szma103aResponse, SZMA103AService } from 'sg-api';
import { ApiCommonService } from 'cbc-shared-lib';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { SgkbConstains } from '../sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSzma103aService {

  private _contractorResult$: Subject<Szma103aResponse> = new Subject<Szma103aResponse>();

  constructor(private sZMA103AService: SZMA103AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  get contractorValueChanges() {
    return this._contractorResult$.asObservable();
  }

  /**
   *　契約情報検索API呼び出し
   *
   * @param {*} value
   * @memberof UsedSzma103aService
   */
  // searchContractor(srvCtrNo: string): Observable<Szma103aResponse> {
  searchContractor(value: any): Observable<Szma103aResponse> {
    // const request: Szma103aRequest = {
    //   ctrSearchInfo: { srvCtrNo },
    // };
    return this.sZMA103AService.c13RSZMA103APost(<Szma103aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      .pipe(
        map(response => {
          this.apiCommonService.checkError(response);
          this._contractorResult$.next(this.setResponseInitialData(response.body));
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_FF,
            SgkbConstains.MESSAGE.APINAME_SZMA103A);
          return throwError(err.message);
        }));
  }

  /**
   * レスポンスに対し、Szma103aResponseの初期表示値を作成
   *
   * @return {*}  {Szma103aResponse}
   * @memberof UsedSzma103aService
   */
  setResponseInitialData(response: Szma103aResponse): Szma103aResponse {

    let elecCtrSearchResultDto = response.elecCtrSearchResultDto;

    if (!elecCtrSearchResultDto.ctrCommonMstInfo || (Object.keys(elecCtrSearchResultDto.ctrCommonMstInfo).length == 0)) {
      elecCtrSearchResultDto.ctrCommonMstInfo = {
        ctrNo: "",
        updateSrno: "",
        srvCtrNo: "",
        prdCode: "",
        prdCtrDate: "",
        prdBreakDate: "",
        firstSrvctrNo: "",
        ctrStateDiv: "",
        ctrStateDivAname: "",
        salfrmCode: "",
        salfrmCodeAname: "",
        rlyisdVisitNo: "",
        rlystrFname: "",
        portalId: "",
        certCode: "",
        payTmprryPw: "",
        agnissVisitNo: "",
        claimMnttmDiv: "",
        claimMnttmDivAname: "",
        cncttoName: "",
        cncttoKanaName: "",
        cncttoTeldv: "",
        cncttoTeldvAname: "",
        cncttoTelNo: "",
        cncttoAddrcd: "",
        cncttoPostno: "",
        cncttoPfcAname: "",
        cncttoPfcKanaAname: "",
        cncttoMptAname: "",
        cncttoMptKanaAname: "",
        cncttoTwareaAname: "",
        cncttoTwareaKanaAname: "",
        cncttoOazaAname: "",
        cncttoOazaKanaAname: "",
        cncttoBanti: "",
        cncttoGou: "",
        cncttoBunptGou: "",
        cncttoSupadrAname: "",
        cncttoSupadrKananm: "",
        cncttoYagouAname: "",
        cncttoYagouKananm: "",
        ctrefctkiStrtdate: "",
        srvctrInfoMemo: "",
        ctrSyuseiDate: "",
        srvctrBreakRsncod: "",
        srvctrBreakRsncodAname: "",
        autksnCtrfrmDiv: "",
        autksnCtrfrmDivAname: "",
        regTrnDate: "",
        ctrcanTrnDate: "",
        ctrEfctedDate: "",
        claimUnit: "",
        claimUnitAname: "",
        rcvmnySiteiMonth: "",
        rcvmnySiteiMonthAname: "",
        ctrnumBrcno: "",
        ctrupdDiv: "",
        ctrupdDivAname: "",
        ctrStrtdt: "",
        ctrEnddt: "",
        prdAname: "",
        prdRyaku: "",
        prdDispAname: "",
        businsCode: "",
        businsCodeAname: "",
        prdClsfyDiv: "",
        prdClsfyDivAname: "",
        srvClsfyCode: "",
        srvClsfyCodeAname: ""
      }
    }
    if (!elecCtrSearchResultDto.hontiGoodsInfo || (Object.keys(elecCtrSearchResultDto.hontiGoodsInfo).length == 0)) {
      elecCtrSearchResultDto.hontiGoodsInfo = {
        goodsCode: "",
        useStartDate: "",
        useEndDate: "",
        ctrExpireDate: "",
        prdGoodsAname: "",
        prdGoodsRyaku: "",
        prdGoodsDisp: "",
        claimFixNo: ""
      }
    }
    if (!elecCtrSearchResultDto.ftiGoodsMstInfo || (Object.keys(elecCtrSearchResultDto.ftiGoodsMstInfo).length == 0 || !elecCtrSearchResultDto.ftiGoodsMstInfo.ftiGoodsMstList)) {
      elecCtrSearchResultDto.ftiGoodsMstInfo = { ftiGoodsMstList: [] };
    }
    if (!elecCtrSearchResultDto.ctrTankaMstInfo || (Object.keys(elecCtrSearchResultDto.ctrTankaMstInfo).length == 0 || !elecCtrSearchResultDto.ctrTankaMstInfo.ctrTankaMstList)) {
      elecCtrSearchResultDto.ctrTankaMstInfo = { ctrTankaMstList: [] };
    }
    if (!elecCtrSearchResultDto.ctrperMstInfo || (Object.keys(elecCtrSearchResultDto.ctrperMstInfo).length == 0)) {
      elecCtrSearchResultDto.ctrperMstInfo = {
        visitNo: "",
        visitKanaName: "",
        visitName: "",
        visitDiv: "",
        visitDivAname: "",
        telNoDiv1: "",
        telNoDiv1Aname: "",
        telNo1: "",
        telNoDiv2: "",
        telNoDiv2Aname: "",
        telNo2: "",
        telNoDiv3: "",
        telNoDiv3Aname: "",
        telNo3: "",
        maddr1: "",
        faxNo1: "",
        addrcd: "",
        postno: "",
        pfcAname: "",
        pfcKanaAname: "",
        mptAname: "",
        mptKanaAname: "",
        twareaAname: "",
        twareaKanaAname: "",
        oazaAname: "",
        oazaKanaAname: "",
        banti: "",
        gou: "",
        bunptGou: "",
        supadrAname: "",
        supadrKananm: "",
        yagouAname: "",
        yagouKananm: ""
      }
    }
    if (!elecCtrSearchResultDto.empposUserMstInfo || (Object.keys(elecCtrSearchResultDto.empposUserMstInfo).length == 0 || !elecCtrSearchResultDto.empposUserMstInfo.empposUserMstList)) {
      elecCtrSearchResultDto.empposUserMstInfo = {
        empposUserMstList: [
          {
            empposMstInfo: {
              logicDeviceNo: "",
              srvClsfyCode: "",
              srvClsfyCodeAname: "",
              extCnnctNo: "",
              addrcd: "",
              postno: "",
              pfcAname: "",
              pfcKanaAname: "",
              mptAname: "",
              mptKanaAname: "",
              twareaAname: "",
              twareaKanaAname: "",
              oazaAname: "",
              oazaKanaAname: "",
              banti: "",
              gou: "",
              bunptGou: "",
              supadrAname: "",
              supadrKananm: "",
              yagouAname: "",
              yagouKananm: ""
            },
            userMstInfo: {
              visitNo: "",
              visitKanaName: "",
              visitName: "",
              visitDiv: "",
              visitDivAname: "",
              telNoDiv1: "",
              telNoDiv1Aname: "",
              telNo1: "",
              telNoDiv2: "",
              telNoDiv2Aname: "",
              telNo2: "",
              telNoDiv3: "",
              telNoDiv3Aname: "",
              telNo3: "",
              maddr1: "",
              faxNo1: "",
              addrcd: "",
              postno: "",
              pfcAname: "",
              pfcKanaAname: "",
              mptAname: "",
              mptKanaAname: "",
              twareaAname: "",
              twareaKanaAname: "",
              oazaAname: "",
              oazaKanaAname: "",
              banti: "",
              gou: "",
              bunptGou: "",
              supadrAname: "",
              supadrKananm: "",
              yagouAname: "",
              yagouKananm: ""
            }
          }
        ]
      };
    }

    elecCtrSearchResultDto.empposUserMstInfo.empposUserMstList.forEach((empposUserMstList) => {

      if (!empposUserMstList.empposMstInfo || (Object.keys(empposUserMstList.empposMstInfo).length == 0)) {
        empposUserMstList.empposMstInfo = {
          logicDeviceNo: "",
          srvClsfyCode: "",
          srvClsfyCodeAname: "",
          extCnnctNo: "",
          addrcd: "",
          postno: "",
          pfcAname: "",
          pfcKanaAname: "",
          mptAname: "",
          mptKanaAname: "",
          twareaAname: "",
          twareaKanaAname: "",
          oazaAname: "",
          oazaKanaAname: "",
          banti: "",
          gou: "",
          bunptGou: "",
          supadrAname: "",
          supadrKananm: "",
          yagouAname: "",
          yagouKananm: ""
        }
      }

      if (!empposUserMstList.userMstInfo || (Object.keys(empposUserMstList.userMstInfo).length == 0)) {
        empposUserMstList.userMstInfo = {
          visitNo: "",
          visitKanaName: "",
          visitName: "",
          visitDiv: "",
          visitDivAname: "",
          telNoDiv1: "",
          telNoDiv1Aname: "",
          telNo1: "",
          telNoDiv2: "",
          telNoDiv2Aname: "",
          telNo2: "",
          telNoDiv3: "",
          telNoDiv3Aname: "",
          telNo3: "",
          maddr1: "",
          faxNo1: "",
          addrcd: "",
          postno: "",
          pfcAname: "",
          pfcKanaAname: "",
          mptAname: "",
          mptKanaAname: "",
          twareaAname: "",
          twareaKanaAname: "",
          oazaAname: "",
          oazaKanaAname: "",
          banti: "",
          gou: "",
          bunptGou: "",
          supadrAname: "",
          supadrKananm: "",
          yagouAname: "",
          yagouKananm: ""
        }
      }
    });

    if (!elecCtrSearchResultDto.elecCtrMstInfo || (Object.keys(elecCtrSearchResultDto.elecCtrMstInfo).length == 0)) {
      elecCtrSearchResultDto.elecCtrMstInfo = {
        transBusCode: "",
        transBusCodeAname: "",
        voltDiv: "",
        voltDivAname: "",
        supplyVoltDiv: "",
        supplyVoltDivAname: "",
        basicKsdate: "",
        claimMnttmDiv: "",
        claimMnttmDivAname: "",
        transMenuCode: "",
        transMenuCodeAname: "",
        eleanKnjnm: "",
        eleanAttach: "",
        eleanTelno: "",
        cnsgmtCtrdcsCode: "",
        cnsgmtCtrdcsCodeAname: "",
        pwrPrcent: 0,
        dmndrdName: "",
        dmndrdAttach: "",
        dmndrdTelno: "",
        pgsupEpower: 0,
        pgsupEpowerUnitcd: "",
        pgsupEpowerUnitcdAname: "",
        splineEpower: 0,
        splineEpowerUnitcd: "",
        splineEpowerUnitcdAname: "",
        stpersplCapa: 0,
        stpersplCapaUniticd: "",
        stpersplCapaUniticdAname: "",
        stiPtn: "",
        stiPtnAname: ""
      }
    }
    if (!elecCtrSearchResultDto.elecConvalMstInfo || (Object.keys(elecCtrSearchResultDto.elecConvalMstInfo).length == 0)) {
      elecCtrSearchResultDto.elecConvalMstInfo = {
        conAmpA: "",
        conAmpAAname: "",
        conCapKva: 0,
        conEleKw: 0,
        lgt0ov10: 0,
        lgt10ov20: 0,
        lgt20ov40: 0,
        lgt40ov60: 0,
        lgt60ov100: 0,
        lgt100Ov: 0,
        lgt200Ov: 0,
        lgt300Ov: 0,
        eqp0ov50: 0,
        eqp50ov100: 0,
        eqp100Ov: 0,
        eqp200Ov: 0,
        eqp300Ov: 0,
        mclc30Flg: "",
        mclc30FlgAname: "",
        redtaxFlg: "",
        redtaxFlgAname: "",
        redtaxPrcnt: "",
        redtaxPrcntAname: "",
        redStrtDate: "",
        redEndDate: "",
        slVltdiv: "",
        slVltdivAname: "",
        sepVltdiv: "",
        sepVltdivAname: ""
      }
    }
    return response;
  }
}
